import UserProfileSubNavDesktopInner from './UserProfileSubNavDesktopInner';
import UserProfileSubNavDesktopInnerContainer from './UserProfileSubNavDesktopInner.container';

export default UserProfileSubNavDesktopInnerContainer(
  UserProfileSubNavDesktopInner
);
